import Loading from "@base/Loading/Loading"

export default Loading;
